import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../../assests/css/admin/AdminDisputedetail.css';
import Adminmasterlayout from '../../../layouts/Adminmasterlayout/Adminmasterlayout';

const AdminDisputeDetail = () => {

  const location = useLocation();

  const navigate = useNavigate();

  const ticket = location.state?.ticket;

  // No Ticket Passed
  if (!ticket) {

    return (

      <Adminmasterlayout>

        <div className="add-container">

          <p className="add-empty-text">
            No Ticket Selected
          </p>

        </div>

      </Adminmasterlayout>

    );

  }

  const userType = ticket.ngteacher_id ? "Teacher" : "Student";

  return (

    <Adminmasterlayout>

      <div className="add-container">

        {/* Header */}
        <div className="add-header">

          <button
            className="add-back-btn"
            onClick={() => navigate(-1)}
          >
            ←
          </button>

          <div className="add-header-info">

            <h1 className="add-title">
              Ticket #{ticket.id}
            </h1>

            <p className="add-subtitle">
              {userType}
            </p>

          </div>

        </div>

        {/* Chat */}
        <div className="add-chat-box">

          <div className="add-message">

            <div className="add-avatar">
              {userType.charAt(0)}
            </div>

            <div className="add-bubble">

              <div className="add-bubble-label">
                {ticket.selectissue}
              </div>

              <p className="add-bubble-text">
                {ticket.describeissue}
              </p>

            </div>

          </div>

        </div>

      </div>

    </Adminmasterlayout>

  );

};

export default AdminDisputeDetail;